/**
 * - Added `AccountBreadcrumbs` to the `first` slot
 */

import { Layout } from '@/data/types/Layout';

export const getCheckoutProfilePage = (): Layout => ({
	name: 'Aside',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'AccountBreadcrumbs', id: 'account-breadcrumbs' }],
		aside: [{ name: 'AccountSidebar', id: 'account-sidebar' }],
		second: [{ name: 'CheckoutProfiles', id: 'checkout-profiles' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
